import type * as THREE from "three";

export const RENDERABLE_LAYER = 0;
export const RAYCASTABLE_LAYER = 1;
export const SNAPPABLE_LAYER = 29;

const HIGHLIGHTABLE_LAYER = 30;
function isHighlightable(sceneObject: THREE.Object3D) {
	return sceneObject.layers.isEnabled(HIGHLIGHTABLE_LAYER);
}

const SELECTABLE_LAYER = 31;
function isSelectable(sceneObject: THREE.Object3D) {
	return sceneObject.layers.isEnabled(SELECTABLE_LAYER);
}

export { HIGHLIGHTABLE_LAYER, isHighlightable, isSelectable, SELECTABLE_LAYER };
